import { camelCase } from '../util.js'
const works = [
  {
    title: '日夜焕亮 一抹传奇',
    desc: '日夜焕亮 一抹传奇',
    thumb: camelCase('cases-brand-maxam-0'),
    zpic: [
      camelCase('cases-brand-maxam-lazyload-01')
    ]
  },
  {
    title: '日夜焕亮 一抹传奇',
    desc: '日夜焕亮 一抹传奇',
    thumb: camelCase('cases-brand-maxam-1'),
    zpic: [
      camelCase('cases-brand-maxam-lazyload-11')
    ]
  },
  {
    title: '日夜焕亮 一抹传奇',
    desc: '日夜焕亮 一抹传奇',
    thumb: camelCase('cases-brand-maxam-2'),
    zpic: [
      camelCase('cases-brand-maxam-lazyload-21')
    ]
  },
  {
    title: '日夜焕亮 一抹传奇',
    desc: '日夜焕亮 一抹传奇',
    thumb: camelCase('cases-brand-maxam-3'),
    zpic: [
      camelCase('cases-brand-maxam-lazyload-31')
    ]
  },
  {
    title: '日夜焕亮 一抹传奇',
    desc: '日夜焕亮 一抹传奇',
    thumb: camelCase('cases-brand-maxam-4'),
    zpic: [
      camelCase('cases-brand-maxam-lazyload-41')
    ]
  },
  {
    title: '日夜焕亮 一抹传奇',
    desc: '日夜焕亮 一抹传奇',
    thumb: camelCase('cases-brand-maxam-5'),
    zpic: [
      camelCase('cases-brand-maxam-lazyload-51')
    ]
  },
  {
    title: '日夜焕亮 一抹传奇',
    desc: '日夜焕亮 一抹传奇',
    thumb: camelCase('cases-brand-maxam-6'),
    zpic: [
      camelCase('cases-brand-maxam-lazyload-61')
    ]
  },
  {
    title: '日夜焕亮 一抹传奇',
    desc: '日夜焕亮 一抹传奇',
    thumb: camelCase('cases-brand-maxam-7'),
    zpic: [
      camelCase('cases-brand-maxam-lazyload-71')
    ]
  },
  {
    title: '日夜焕亮 一抹传奇',
    desc: '日夜焕亮 一抹传奇',
    thumb: camelCase('cases-brand-maxam-8'),
    zpic: [
      camelCase('cases-brand-maxam-lazyload-81')
    ]
  },
  {
    title: '日夜焕亮 一抹传奇',
    desc: '日夜焕亮 一抹传奇',
    thumb: camelCase('cases-brand-maxam-9'),
    zpic: [
      camelCase('cases-brand-maxam-lazyload-91')
    ]
  },
  {
    title: '日夜焕亮 一抹传奇',
    desc: '日夜焕亮 一抹传奇',
    thumb: camelCase('cases-brand-maxam-10'),
    zpic: [
      camelCase('cases-brand-maxam-lazyload-101')
    ]
  },
  {
    title: '日夜焕亮 一抹传奇',
    desc: '日夜焕亮 一抹传奇',
    thumb: camelCase('cases-brand-maxam-11'),
    zpic: [
      camelCase('cases-brand-maxam-lazyload-111')
    ]
  },
  {
    title: '日夜焕亮 一抹传奇',
    desc: '日夜焕亮 一抹传奇',
    thumb: camelCase('cases-brand-maxam-12'),
    zpic: [
      camelCase('cases-brand-maxam-lazyload-121')
    ]
  },
  {
    title: '日夜焕亮 一抹传奇',
    desc: '日夜焕亮 一抹传奇',
    thumb: camelCase('cases-brand-maxam-13'),
    zpic: [
      camelCase('cases-brand-maxam-lazyload-131')
    ]
  },
  {
    title: '日夜焕亮 一抹传奇',
    desc: '日夜焕亮 一抹传奇',
    thumb: camelCase('cases-brand-maxam-14'),
    zpic: [
      require('../../assets/cases-brand-maxam-lazyload-141.mp4')
    ]
  }
]
export default {
  name: '美加净',
  logo: {
    default: camelCase('cases-brand-17'),
    active: camelCase('cases-brand-17-cover')
  },
  works
}
